/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
"use strict";
/** @typedef {{new(): Hash}} HashConstructor */

/**
 * @typedef {Object} Hash
 * @property {function(string|Buffer, string=): Hash} update
 * @property {function(string): string} digest
 */

var _classCallCheck = require("C:\\Users\\Amir-PC\\Documents\\Zepcom\\Natca\\Natca.Web\\ClientApp\\node_modules\\react-scripts\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\Amir-PC\\Documents\\Zepcom\\Natca\\Natca.Web\\ClientApp\\node_modules\\react-scripts\\node_modules\\@babel\\runtime/helpers/createClass");

var BULK_SIZE = 1000;
/**
 * @implements {Hash}
 */

var BulkUpdateDecorator = /*#__PURE__*/function () {
  function BulkUpdateDecorator(hash) {
    _classCallCheck(this, BulkUpdateDecorator);

    this.hash = hash;
    this.buffer = "";
  }

  _createClass(BulkUpdateDecorator, [{
    key: "update",
    value: function update(data, inputEncoding) {
      if (inputEncoding !== undefined || typeof data !== "string" || data.length > BULK_SIZE) {
        if (this.buffer.length > 0) {
          this.hash.update(this.buffer);
          this.buffer = "";
        }

        this.hash.update(data, inputEncoding);
      } else {
        this.buffer += data;

        if (this.buffer.length > BULK_SIZE) {
          this.hash.update(this.buffer);
          this.buffer = "";
        }
      }

      return this;
    }
  }, {
    key: "digest",
    value: function digest(encoding) {
      if (this.buffer.length > 0) {
        this.hash.update(this.buffer);
      }

      var digestResult = this.hash.digest(encoding);
      return typeof digestResult === "string" ? digestResult : digestResult.toString();
    }
  }]);

  return BulkUpdateDecorator;
}();
/* istanbul ignore next */


var DebugHash = /*#__PURE__*/function () {
  function DebugHash() {
    _classCallCheck(this, DebugHash);

    this.string = "";
  }

  _createClass(DebugHash, [{
    key: "update",
    value: function update(data, inputEncoding) {
      if (typeof data !== "string") data = data.toString("utf-8");
      this.string += data;
      return this;
    }
  }, {
    key: "digest",
    value: function digest(encoding) {
      return this.string.replace(/[^a-z0-9]+/gi, function (m) {
        return Buffer.from(m).toString("hex");
      });
    }
  }]);

  return DebugHash;
}();
/**
 * Creates a hash by name or function
 * @param {string | HashConstructor} algorithm the algorithm name or a constructor creating a hash
 * @returns {Hash} the hash
 */


module.exports = function (algorithm) {
  if (typeof algorithm === "function") {
    return new BulkUpdateDecorator(new algorithm());
  }

  switch (algorithm) {
    // TODO add non-cryptographic algorithm here
    case "debug":
      return new DebugHash();

    default:
      return new BulkUpdateDecorator(require("crypto").createHash(algorithm));
  }
};